var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"session-avatar",class:{
    'has-image': _vm.hasImage,
    'group-chat': _vm.session.type === 'group' && !_vm.hasImage
  },style:(_vm.avatarStyle)},[(_vm.hasImage)?void 0:(_vm.session.type === 'group')?[_c('span',{staticClass:"group-node a"},[_vm._v(_vm._s(_vm.getGroupNodes()[0]))]),_c('span',{staticClass:"group-node b"},[_vm._v(_vm._s(_vm.getGroupNodes()[1]))]),_c('span',{staticClass:"group-node c"},[_vm._v(_vm._s(_vm.getGroupNodes()[2]))])]:[_vm._v(" "+_vm._s(_vm.getAvatarText())+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }